var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "79tzbh4r8b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60D66A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-33.3%",
    y: "-33.3%",
    width: "166.7%",
    height: "166.7%",
    filterUnits: "objectBoundingBox",
    id: "invjp2tf9a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.647058824 0 0 0 0 0.678431373 0 0 0 0 0.741176471 0 0 0 1 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#invjp2tf9a)",
    transform: "translate(2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.623 35.377 2.455-8.924a17.13 17.13 0 0 1-2.31-8.61C.772 8.349 8.535.624 18.072.624c4.63.002 8.974 1.796 12.24 5.051a17.074 17.074 0 0 1 5.064 12.183c-.004 9.496-7.767 17.221-17.303 17.221h-.008a17.36 17.36 0 0 1-8.268-2.095L.623 35.377z",
    fill: "url(#79tzbh4r8b)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.595 10.38c-.335-.742-.688-.757-1.007-.77-.262-.01-.56-.01-.859-.01-.298 0-.784.112-1.194.558-.41.446-1.568 1.524-1.568 3.718s1.605 4.314 1.829 4.612c.224.297 3.098 4.942 7.65 6.73 3.784 1.485 4.554 1.19 5.375 1.115.821-.074 2.65-1.078 3.023-2.12.374-1.04.374-1.933.262-2.12-.112-.185-.411-.297-.859-.52-.448-.223-2.65-1.301-3.06-1.45-.411-.149-.71-.223-1.008.223-.299.446-1.157 1.45-1.418 1.748-.261.298-.523.335-.97.112-.448-.224-1.89-.694-3.602-2.213-1.332-1.182-2.23-2.641-2.492-3.088-.261-.446-.028-.687.197-.91.201-.2.448-.52.672-.78.223-.26.298-.446.447-.744.15-.297.075-.558-.037-.78-.112-.224-.982-2.429-1.38-3.31z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.755 5.232C27.37 1.86 22.87.002 18.075 0 8.195 0 .155 8.002.15 17.838a17.745 17.745 0 0 0 2.393 8.918L0 36l9.502-2.48a17.976 17.976 0 0 0 8.566 2.171h.007c9.88 0 17.92-8.003 17.925-17.839a17.69 17.69 0 0 0-5.245-12.62zm-12.68 27.446h-.005a14.93 14.93 0 0 1-7.583-2.067l-.545-.321-5.638 1.472 1.505-5.471-.355-.561a14.739 14.739 0 0 1-2.277-7.89C3.18 9.663 9.863 3.012 18.08 3.012c3.98.002 7.72 1.546 10.533 4.348a14.703 14.703 0 0 1 4.36 10.49c-.004 8.176-6.687 14.827-14.899 14.827z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.6295523d0ebd3d76984220c2e1676e2c.svg";
export { ForwardRef as ReactComponent };